import React, {Component} from 'react';
import Badge from "./Badge";
import {connect} from 'react-redux';
import {actions as engine} from "../../reducers/engine";

@connect(
    state => {
        return {
            queuedJobs: state.engine.queuedJobs,
            executingJobs: state.engine.executingJobs,
            successfulJobs: state.engine.successfulJobs,
            failedJobs: state.engine.failedJobs
        }
    },
    dispatch => {
        return {
            fetchJobs: () => dispatch(engine.fetch()),
            retryJobs: (jobId) => dispatch(engine.retry(jobId)),
        };
    }
)
export default class EngineInfo extends Component {
    componentDidMount() {
        this.fetchJobs();
    }

    fetchJobs() {
        this.props.fetchJobs();
        this.timeout = setTimeout(() => this.fetchJobs(), 2000);
    }

    render() {

        return(
            <div>
                <Badge value={this.props.queuedJobs?this.props.queuedJobs.length:0} color='primary' hoverText='Queued Jobs'/>
                <Badge value={this.props.executingJobs?this.props.executingJobs.length:0} color='info' hoverText='Jobs in execution'/>
                <Badge value={this.props.successfulJobs?this.props.successfulJobs.length:0} color='success' hoverText='Successful jobs'/>
                <Badge value={this.props.failedJobs?this.props.failedJobs.length:0} color='danger' hoverText='Failed jobs'/>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./React/src/components/EngineInfo/EngineInfo.js